module.exports = {
  ENV: 'prod',
  APP_NAME: 'veolia',
  END_POINT: 'https://ssm.services.apihf.com',
  API_KEY: '96K4mzfiSr6zDfqfvAOWS3yP3msLsHrR5pLjhYUy',
  BRAND_KEY: 'b2b26328-27e3-4fd0-857d-12989a31901e',
  LANG: 'fr-FR'
}